import { cn } from '../lib/cn'
import { IconLoader } from '../lib/icons'

/*
 * An indeterminate wait (family 8). It owns the `role="status"`, so the label is required;
 * `label=''` makes it silent for a spinner beside its own caption. Prefer Skeleton when the
 * final shape is known.
 */

export interface SpinnerProps {
  /** Announced and visually hidden, or `''` when the surroundings announce already. */
  label: string
  /** `md` stands alone (a page state); `sm` fits inline next to text. */
  size?: 'sm' | 'md'
  className?: string
}

const SIZES = {
  sm: 'size-4',
  md: 'size-6',
} as const

export function Spinner({ label, size = 'md', className }: SpinnerProps) {
  const decorative = label === ''
  return (
    <span
      role={decorative ? undefined : 'status'}
      aria-hidden={decorative || undefined}
      className={cn('inline-flex text-muted-foreground', className)}
    >
      <IconLoader aria-hidden="true" className={cn(SIZES[size], 'animate-spin')} />
      {decorative ? null : <span className="sr-only">{label}</span>}
    </span>
  )
}
